<template>
<div>
	<v-dialog v-model="mmsDialog" content-class="dialog with-fixed-actions bg-white" width="1100" max-height="95%" height="1200" activator="">
            <div class="dialog-header">
                <v-toolbar class="bg-white">
                    <h1 class="mb-0" v-if="!viewedMeeting">Insert Meeting</h1>
                    <h1 class="mb-0" v-else>Meeting Details</h1>
                    <v-spacer></v-spacer>
                    <div class="custom-icon-wrapper">
                        <v-icon @click="mmsDialog = false">custom-icon mdi-close</v-icon>
                    </div>
                </v-toolbar>
            </div>
            <div class="dialog-body">
            </div>
    </v-dialog>
	<v-btn @click="mmsDialog = !mmsDialog">Open Meeting Form</v-btn>

	<div class="avatar">
		<img  alt="Avatar" class="avatar-image" />
		<div class="avatar-name">fsdf</div>
	  </div>

	
	<div class="text-center">
		<v-menu
		  v-model="menu"
		  :close-on-content-click="false"
		  :nudge-width="200"
		  offset-x
		>
		  <template v-slot:activator="{ on, attrs }">
			<v-btn
			  color="indigo"
			  dark
			  v-bind="attrs"
			  v-on="on"
			>
			  Menu as Popover
			</v-btn>
		  </template>
	
		  <v-card>
	
		  </v-card>
		</v-menu>
	</div>
    <div class="col-md-4">
        <Container @drop="onDrop" drag-handle-selector=".column-drag-handle" drag-class="opacity-ghost">
            <Draggable drag-handle-selector=".column-drag-handle">

                <div class="col-md-12 p-0">
                    <label class="label_required" style="cursor:pointer">Filing Plan *</label>
                    <div class="d-flex align-items-center column-drag-handle">
                        <v-icon style="bottom: 10px;cursor:pointer;">mdi-dots-vertical</v-icon>
						<div class="with-absolute-button flex-1" style="padding-bottom: 20px;">
							<FilingClassificationPlanSelector :mode="filingClassificationPlanMode.FilingPlanMode"></FilingClassificationPlanSelector>
						</div>
                    </div>
                </div>
                <div class="col-md-12 p-0">
                    <label class="label_required" style="cursor:pointer">Classification *</label>
                    <div class="d-flex align-items-center column-drag-handle">
                        <v-icon style="bottom: 10px;cursor:pointer;">mdi-dots-vertical</v-icon>
						<div class="with-absolute-button flex-1" style="padding-bottom: 20px;">
							<FilingClassificationPlanSelector :mode="filingClassificationPlanMode.ClassificationPlanMode"></FilingClassificationPlanSelector>
						</div>
                    </div>
                </div>
            </Draggable>
        </Container>
    </div>
		

		<div class="col-md-4">
			<Container @drop="onDrop" drag-handle-selector=".column-drag-handle" drag-class="opacity-ghost" >
				<Draggable v-for="(item, index) in items" :key="index" drag-handle-selector=".column-drag-handle">
					<div class="col-md-12 p-0">
						<label class="label_required" style="cursor:pointer">{{ $t("res_Label_Signee") + index}} *</label>
						<div class="d-flex align-items-center column-drag-handle">
							<v-icon style="bottom: 10px;cursor:pointer;">mdi-dots-vertical</v-icon>
							<div class="with-absolute-button flex-1" style="padding-bottom: 20px;">
								<StructureUserSelector :showInternalUsers="true" :showExternalUsers="false"
									:excludeSelf="true" :isMultiple="false" :selectedStructureUser="items[index]" 
									@structureUserSelectChanged="documentSigneeSelectedChange" :dataToPassOnSelectChange="index">
								</StructureUserSelector>
							</div>
						</div>
					</div>
				</Draggable>
			</Container>
		</div>
		


		<br/>
		<br/>
		<br/>
		<br/>


		<v-btn @click="openTracker">
			Open New Tracker
		</v-btn>
		<v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y
			max-width="290px" min-width="auto">
			<template v-slot:activator="{ on, attrs }">
				<v-text-field v-model="dateFormatted" label="Date" hint="MM/DD/YYYY format" persistent-hint
					prepend-icon="mdi-calendar" v-bind="attrs" @blur="date = parseDate(dateFormatted)"
					v-on="on"></v-text-field>
			</template>
			<v-date-picker v-model="date" no-title @input="menu1 = false"></v-date-picker>
		</v-menu>
		<p>Date in ISO format: <strong>{{ date }}</strong></p>

		<span v-tooltip="'You have ' + 1 + ' new messages.'">
			Click Me
		</span>

		<br />
		<br />
		<br />


		<v-text-field v-model="emailToCheck" :rules="rules" hide-details="auto" label="Email" solo></v-text-field>
		<br />
		<v-text-field v-model="emailToCheck2" label="Email" solo></v-text-field>

		<div style="width: 400px">
			a1
			<multi-select class="light-bg Separated" v-model="selectedItems" label="name" track-by="id"
				open-direction="bottom" :options="items1" :searchable="true" :loading="loading" :internal-search="false"
				:clear-on-select="false" :close-on-select="true" :options-limit="300" :max-height="600"
				:show-no-results="false" :hide-selected="true" :multiple="true" @search-change="asyncFindItems1">
				<template slot="option" slot-scope="props">
					<div style="height: 50px; width: 100%; display: flex">
						<!-- <div class="" style="">
							<v-avatar color="#eff2f5" size="43">
								<v-lazy-image class="progressive-demo"
									:src="constants.baseApiUrl + 'StructureUser/profile?userStructureId=' + props.option.id + '&isUser=' + props.option.isUser"
									src-placeholder="/assets/images/icons/loader.svg"
									:intersection-options="{ rootMargin: '0px' }">
								</v-lazy-image>
							</v-avatar>
						</div> -->
						<div class="ad__box" v-if="props.option.isUser">
							<p class="ad__text__bold">{{ props.option.name }}</p>
							<p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}</p>
						</div>
						<div class="ad__box" v-else>
							<p class="ad__text__bold">{{ props.option.name }}</p>
							<p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}</p>
						</div>
					</div>
				</template>
				<template slot="noOptions" slot-scope="props">
					{{ $t("res_Msgs_EmptySearch") }}
				</template>
			</multi-select>
			a2
			<multi-select class="light-bg Separated" v-model="selectedItems" label="name" track-by="id"
				open-direction="bottom" :options="items1" :searchable="true" :loading="loading" :internal-search="false"
				:clear-on-select="false" :close-on-select="true" :options-limit="300" :max-height="600"
				:show-no-results="false" :hide-selected="true" :multiple="true" @search-change="debouncedHandler">
				<template slot="option" slot-scope="props">
					<div style="height: 50px; width: 100%; display: flex">
						<!-- <div class="" style="">
							<v-avatar color="#eff2f5" size="43">
								<v-lazy-image class="progressive-demo"
									:src="constants.baseApiUrl + 'StructureUser/profile?userStructureId=' + props.option.id + '&isUser=' + props.option.isUser"
									src-placeholder="/assets/images/icons/loader.svg"
									:intersection-options="{ rootMargin: '0px' }">
								</v-lazy-image>
							</v-avatar>
						</div> -->
						<div class="ad__box" v-if="props.option.isUser">
							<p class="ad__text__bold">{{ props.option.name }}</p>
							<p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}</p>
						</div>
						<div class="ad__box" v-else>
							<p class="ad__text__bold">{{ props.option.name }}</p>
							<p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}</p>
						</div>
					</div>
				</template>
				<template slot="noOptions" slot-scope="props">
					{{ $t("res_Msgs_EmptySearch") }}
				</template>
			</multi-select>
		</div>
		<br />
		<br />
		<div style="width: 700px">
			<v-menu content-class="p-0" v-model="document_date_menu" :close-on-content-click="false"
				transition="scale-transition" offset-y min-width="auto">
				<template v-slot:activator="{ on, attrs }">
					<v-text-field min-width="300" v-model="document_date" label="" readonly v-bind="attrs" v-on="on" solo
						append-icon="mdi-calendar">
					</v-text-field>
				</template>
				<v-date-picker style="width: 100%" v-model="document_date"
					@input="document_date_menu = false"></v-date-picker>
			</v-menu>
		</div>

		<br />
		<div>
			{{ selectedItems }}
		</div>

		<div>
			<v-btn @click="OpenConfigureSignature">Configure Signature</v-btn>
			<v-btn @click="dialog1 = true">Open Sample Dialog</v-btn>
			<v-btn @click="dialog2 = true">Open Signing History</v-btn>
			<v-btn @click="dialog3 = true">Open Visual Tracking</v-btn>
			<v-btn @click="dialog4 = true">Open Visual Tracking - Incoming</v-btn>
		</div>

		<v-dialog
		 fullscreen
      	 content-class="fullscreen-dialog"
		  v-model="tracker_dialog"> 
			<!-- <TemplatePreview :templateId="1494" :closeDialogFunc="ClosePrev"  /> -->
			<TrackingView2  :documentId="114359" :closeDialogFunc="ClosePrev" />
		</v-dialog>

		<v-dialog v-model="dialog1" content-class="small-dialog" width="500" height="350">
			<v-card>
				<v-card-title>
					Rename Attachment
				</v-card-title>
				<div class="card-body">
					<label class="mb-2">Pin Code</label>
					<v-text-field label="Type here" solo></v-text-field>

					<v-data-table :mobile-breakpoint="0" class="position-relative pt-5 hide_footer white" disable-sort
						:headers="grid_headers" :items-per-page="5" :items="grid_items" :loading="loading"
						loading-text="loading..." :no-data-text="$t('res_Label_NoData')"
						:footer-props="{ 'items-per-page-text': 'Items per page' }" caption=""
						:class="{ 'result_available': grid_items.length != 0 }" header-fixed fixed-header>
						<template v-slot:item="row">
							<tr>
								<td>{{ row.item.recipientName }}</td>
								<td>{{ row.item.title }}</td>
								<td>{{ row.item.name }}</td>
								<td>
									<div class="d-flex">
										<v-btn class="white--text" elevation="2" color="#00ae8d">{{
											$t("res_ButtonText_Edit") }}</v-btn>
										<v-btn class="white--text ml-3" elevation="2" color="#ff902b">{{
											$t("res_ButtonText_Add") }}</v-btn>
									</div>
								</td>
							</tr>
						</template>
					</v-data-table>
				</div>
				<v-card-actions class="gap-2 sticky-actions">
					<v-spacer></v-spacer>
					<v-btn class="light-blue" @click="dialog2 = true">Open Dialog 2</v-btn>
					<v-btn class="primary" @click="display_loader = true">Show Loading</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialog2" content-class="dialog with-sticky-actions bg-white w-40 right" fullscreen width="70%"
			scrollable>
			<v-card class="bg-white">
				<v-toolbar class="bg-white">
					<v-card-title>
						Signing History
					</v-card-title>
					<v-spacer></v-spacer>
					<v-btn class="close-btn light-btn" icon dark>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-toolbar>
				<v-card-text class="border-top p-0">
					<SigningHistory></SigningHistory>
				</v-card-text>
				<v-card-actions class="p-3">
					<v-btn class="light-blue w-100" style="height: 48px" @click="dialog2 = false"><img class="rtl-flip"
							src="/assets/images/icons/tracking.svg" />Tracking</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialog3" content-class="tracker-container dialog with-sticky-actions bg-white" width="100%"
			fullscreen>
			<div class="dialog-header">
				<div class="custom-icon-wrapper">
					<v-icon>custom-icon left-arrow-icon</v-icon>
				</div>
				<v-btn class="close-btn light-btn tracker-close" icon dark @click="dialog3 = false">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</div>
			<div class="dialog-body h-100 w-100">
				asdasdasdasd
				<iframe id="trackingFrame" :src="trackingFrameSrc" style="width: 100%; height: 100%;"></iframe>
			</div>
		</v-dialog>

		<v-dialog v-model="dialog4" content-class="dialog tracker-container with-sticky-actions bg-white" width="100%"
			fullscreen>
			<div class="dialog-header">
				<v-btn class="close-btn light-btn tracker-close" icon dark @click="dialog4 = false">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</div>
			<div class="dialog-body h-100">
				asdasdasdasddd
				<iframe id="trackingFrame2" :src="trackingFrameSrc2" style="width: 100%; height: 100%;"></iframe>
			</div>
		</v-dialog>

		<v-dialog v-model="dialog5" content-class="dialog tracker-container with-sticky-actions bg-white" width="100%"
			fullscreen>
			<div class="dialog-header">
				<v-btn class="close-btn light-btn tracker-close" icon dark @click="dialog5 = false">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</div>
			<div class="dialog-body h-100">
				asdasdasdasd
				<iframe id="trackingFrame22" :src="trackingFrameSrc22" style="width: 100%; height: 100%;"></iframe>
			</div>
		</v-dialog>

		<div v-if="display_loader" class="cts_loader">
			<v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
			<p class="mt-4">Almost there....</p>
		</div>

		<div style="position: absolute; right: 500px; top: 500px;">

			<v-menu content-class="align-menu-bottom down-arrow" top offset-y offset-x right :close-on-click="false"
				:close-on-content-click="false" :value="shown">

				<template v-slot:activator="{ on, attrs }">
					<v-btn v-bind="attrs" v-on="on" @click="shown = true" class="light-blue red-noti"
						style="width: 45px; min-width: unset !important"><v-icon color="primary">mdi-chat</v-icon>
					</v-btn>
				</template>

				<v-card class="p-3 shadow-none" style="max-width: 400px;">
					<v-toolbar class="shadow-none bg-white align-items-start">
						<div class="gap-3 align-items-start d-flex">
							<div class="user"><img src="/assets/images/samples/user.svg" /></div>
							<div>
								<v-card-title class="size-16 dark-title py-0 px-0">Ahmed Rashid Al Marzouqi</v-card-title>
								<p class="size-14 text-secondary">Line Manager</p>
							</div>
						</div>
						<v-spacer></v-spacer>
						<v-btn @click="shown = false" class="close-btn light-btn" icon dark>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-toolbar>

					<p class="text-secondary mb-1">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
						tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
						exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure... </p>

					<v-btn class="btn-text text-primary">See all Comments</v-btn>
				</v-card>
			</v-menu>
		</div>

	</div>
</div>
</template>

<script>
import MultiSelect from 'vue-multiselect'
import axios from 'axios'
import constants from '@/assets/js/constants.js'
import * as utils from '@/assets/js/common.js'
import SigningHistory from '@/components/SigningHistory.vue'
import TrackingTree from '@/components/TrackingTree.vue'
import SignatureConfigure from '@/components/SignatureConfigure.vue'
import debounce from "lodash.debounce"
import TrackingView2 from '@/views/TrackingView2.vue'
import { Container, Draggable } from 'vue-smooth-dnd'
import StructureUserSelector from '@/components/StructureUserSelector.vue'
import FilingClassificationPlanSelector from '@/components/FilingClassificationPlanSelector.vue'
import TemplatePreview from './admin/TemplatePreview.vue'


export default {
	name: 'test',
	components: {
      TemplatePreview, MultiSelect, SigningHistory, TrackingTree, SignatureConfigure, TrackingView2, Container, Draggable, StructureUserSelector, FilingClassificationPlanSelector
	},
	data() {
		return {
			loading: false,
			items1: [],
			rules: [
				value => !!value || 'The data input is invalid.'
			],

			offset: true,
			shown: false,
			filter_purpose: { id: -1, name: 'select *' },
			selectedItem: {},
			selectedItems: [{}],

			dialog1: false,
			dialog2: false,
			dialog3: false,
			dialog4: false,
			dialog5: false,
			display_loader: false,
			trackingFrameSrc: '',
			trackingFrameSrc2: '',
			trackingFrameSrc22: '',
			mmsDialog: false,

			lstSignees: ['1#Hussein Naseer#Developer 1', '2#Yahya Ahmed#Developer 2', '3#Usman Siddiqui#Developer 3'],
			maxNumberOfSigners: 0,
			attachementHeading: 'Sick leave_Ahmad',

			grid_items: [],
			grid_headers: [
				{ text: 'Id', value: 'id', align: ' d-none' },
				{ text: 'External', value: 'external', align: ' d-none' },
				{ text: 'Email', value: 'email', align: ' d-none' },
				{ text: 'Designation', value: 'profession', align: ' d-none' },
				{ text: 'Recipient Name', value: 'recipientName', width: '25%' },
				{ text: 'Title', value: 'title', width: '10%' },
				{ text: 'Designated Person', value: 'name', width: '30%' },
				{ text: '', value: '', width: '25%' }
			],
			value: null,
			options: [{ id: 1, name: 'test 1' }, { id: 2, name: 'test 2' }],
			document_date_menu: false,
			document_date: new Date().toISOString().substr(0, 10),

			emailToCheck: '',
			emailToCheck2: '',
			debouncedHandler: null,
			tracker_dialog: false,
			menu1: false,
			date: '',
			dateFormatted: '',
			items: [{id:1}, {id:2}, {id:3}],
			selectedUser: {},
            //FilingClassificationPlan
            filingClassificationPlanMode: {
                FilingPlanMode: 1,
                ClassificationPlanMode: 2,
                BothPlanModes: 3
            }
		}
	},
	beforeMount() {
		console.log(this.debouncedHandler)
		this.debouncedHandler = debounce(query => {
			axios.get(constants.baseApiUrl + 'StructureUser/search?showUsers=true&showInternalStructures=true&showExternalStructures=false&search=' + query)
				.then(res => { this.items1 = res.data })
				.catch(err => { console.log(err) });
		}, 200);
		console.log(this.debouncedHandler)
	},
	mounted() {
		this.trackingFrameSrc = 'resources/VisualTracking/VisualTracking.html?DocumentId=100609'
		this.trackingFrameSrc2 = 'resources/VisualTracking/VisualTracking.html?DocumentId=100544'

		console.log(this.trimTextWithKeyword('this is a text', 'is'))
		console.log(this.trimTextWithKeyword('this is a text', 'on'))
		console.log(this.trimTextWithKeyword('this is a text this is a text is', 'is'))
		console.log(this.trimTextWithKeyword('th a text th a text th a text is', 'is'))
	},
	methods:
	{  
		onDrop(dropResult) 
		{
			this.items = utils.applyDrag(this.items, dropResult)
		}, 
		getGhostParent() {
			return document.body;
		},
		onDropReady(dropResult) {
			console.log('drop ready', dropResult);
		},
		documentSigneeSelectedChange(item, index) 
		{
            //// this.document.signers[index] = item;
            //used below way to fix an issue (above is not reflecting on the page because activity is lost)
            this.$set(this.items, index, item);
        },
		openTracker() {
			this.tracker_dialog = true
		},
		OpenConfigureSignature() {
			this.trackingFrameSrc22 = 'resources/configureSignature/ConfigureSignature.html?r=' + new Date().getTime()
			this.dialog5 = true
		},
		async asyncFindItems1(query) {
			if (query == '') return;
			axios.get(constants.baseApiUrl + 'StructureUser/search?showUsers=true&showInternalStructures=true&showExternalStructures=false&search=' + query)
				.then(res => {
					this.items1 = res.data;
					this.loading = false;
				})
				.catch(err => {
					console.log(err);
				});
		},
		async asyncFindItems2(query2) {
			console.log(query2)
		},
		removeItem(itemId) {
			this.selectedItems = this.selectedItems.filter(item => item.id !== itemId);
		},
		CapitalizeFirstLetter(string) {
			return utils.CapitalizeFirstLetter(string)
		},
		GetMultiSelectSubHeaderDisplay(options) {
			return utils.GetMultiSelectSubHeaderDisplay(options)
		},ClosePrev() { 
      this.tracker_dialog = false;
    },
		isValidEmail(email) {
			// Check if email contains only spaces
			if (email.trim() === "")
				return false;

			// Check if email contains '@' character
			if (!email.includes('@'))
				return false;

			// Check if email contains '@@'
			if (email.includes('@@'))
				return false;

			// Check if email contains spaces
			if (/\s/.test(email))
				return false;

			// Split email into local and domain parts
			const [localPart, domainPart] = email.split('@');

			// Check if local part is empty or starts/ends with a dot
			if (!localPart || localPart.startsWith('.') || localPart.endsWith('.'))
				return false;

			// Check if domain part is empty or starts/ends with a dot
			if (!domainPart || domainPart.startsWith('.') || domainPart.endsWith('.'))
				return false;

			// Check if domain part contains a dot (to ensure a top-level domain is present)
			if (!domainPart.includes('.'))
				return false;

			// Regular expression to check for a valid domain
			const domainRegex = /^(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)\.)*(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9]))\.([a-zA-Z]{2,})$/;

			// Regular expression to check for a valid IP address
			const ipRegex = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])$/;

			// Check if domain part is an invalid IP address
			if (domainRegex.test(domainPart) || ipRegex.test(domainPart))
				return true;
			else
				return false;

			return true;
		},
		trimTextWithKeyword(text, keyword) {
			const maxLength = 10; // Maximum length of the trimmed text
			const keywordIndex = text.toLowerCase().indexOf(keyword.toLowerCase());

			if (keywordIndex === -1) {
				// If the keyword is not found, return the trimmed text without the keyword
				return text.substring(0, maxLength).trim();
			}

			const startIndex = Math.max(0, keywordIndex - Math.floor((maxLength - keyword.length) / 2));
			let trimmedText = text.substring(startIndex, startIndex + maxLength).trim();

			if (startIndex > 0) {
				// Prepend "..." if the trimmed text does not start from the beginning of the original text
				trimmedText = `...${trimmedText}`;
			}

			if (startIndex + maxLength < text.length) {
				// Append "..." if the trimmed text does not reach the end of the original text
				trimmedText = `${trimmedText}...`;
			}

			return trimmedText;
		},
		formatDate(date) {
			if (!date) return null

			const [year, month, day] = date.split('-')
			return `${month}/${day}/${year}`
		}
	},
	watch:
	{
		emailToCheck: function (newVal, oldVal) {
			if (this.isValidEmail(newVal)) {
				this.emailToCheck2 = 'valid'
			}
			else {
				this.emailToCheck2 = 'invalid'
			}
		},
		date(val) {
			this.dateFormatted = this.formatDate(this.date)
		}
	}
};

</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.ad__box {
	margin-left: 9px;
	margin-right: 9px;
	padding-top: 6px;
}

.ad__text {
	margin-bottom: 5px;
}

.ad__text__bold {
	font-weight: bold;
}

.ad__box p {
	margin-bottom: 0px;
}

.multiselect__option--highlight .v-avatar {
	color: #205CDF !important;
}

	.opacity-ghost { transition: all .18s ease; opacity: 0.8; }
	.opacity-ghost-drop { opacity: 1; background-color: white; box-shadow: 3px 3px 10px 3px rgba(0, 0, 0, 0.0); }
	.opacity-ghost label, .opacity-ghost .v-icon, .opacity-ghost button { display: none; }
	.opacity-ghost .multiselect__tags { background: white !important; }


	.avatar {
		display: flex;
		flex-direction: column;
		align-items: center;
	  }
	  
	  .avatar-image {
		width: 80px;
		height: 80px;
		border-radius: 50%;
		margin-bottom: 8px;
	  }
	  
	  .avatar-name {
		font-size: 14px;
		font-weight: bold;
	  }
</style>